import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

function init(parent) {
  const swiperElement = parent.querySelector('.main-categories__swiper');
  const tabs = parent.querySelectorAll('.main-categories__item');
  const links = document.querySelectorAll('.main-categories__category');
  const sections = document.querySelectorAll('.main-categories__section');
  const swiper = new Swiper(swiperElement, {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 1,
    //init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        enabled: false,
      },
    },
  });

  const gotoSection = (newIdx) => {
    links.forEach((link, idx) => {
      const tab = tabs[idx];
      const section = sections[idx];
      if (idx === newIdx) {
        link.setAttribute('aria-selected', true);
        link.classList.add('is-active');
        section.hidden = false;
      } else {
        link.removeAttribute('aria-selected');
        link.classList.remove('is-active');
        section.hidden = true;
      }
    });
  };

  swiper.on('slideChange', (swiper) => {
    gotoSection(swiper.realIndex);
  });

  gotoSection(0);
  links.forEach((link, idx) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      gotoSection(idx);
      swiper.slideTo(idx);
    });
  });
}

export function mainCategories(selector = '.main-categories') {
  document.querySelectorAll(selector).forEach((element) => init(element));
}
